import { AfterViewInit, Component, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MessageBusService } from '@xdig/ng-microkernel/micro-frontend';
import { Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'shell-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
})
export class OverlayComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  queue: object[] = [];
  enabled: boolean;

  constructor(private messageBus: MessageBusService, private cd: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.onLoadingAnimation();
  }

  private onLoadingAnimation(): void {
    this.messageBus
      .on$('shell.animation', 'loading.begins')
      .pipe(
        takeUntil(this.destroy$),
        tap(() => (this.queue = [...this.queue, {}])),
        filter(() => this.queue.length === 1),
        tap(() => {
          if (!!this.queue.length) {
            this.enabled = true;
            this.cd.detectChanges();
          }
        }),
      )
      .subscribe();

    this.messageBus
      .on$('shell.animation', 'loading.ends')
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.queue.pop()),
        filter(() => !this.queue.length),
        tap(() => {
          if (!this.queue.length) {
            this.enabled = false;
            this.cd.detectChanges();
          }
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
